import React from 'react';
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import KwzidaRouter from './KwzidaRouter';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App">
      <KwzidaRouter></KwzidaRouter>
      <ToastContainer />
    </div>
  );
}

export default App;
